import { Action } from '@ngrx/store'
import * as businessesTypes from './businesses.types'
import { Organization } from './businesses.interface'

export class FetchBusinessesRequest implements Action {
  readonly type = businessesTypes.FETCH_BUSINESSES_REQUEST
  constructor(public payload: any = {}) {}
}

export class FetchBusinessesSuccess implements Action {
  readonly type = businessesTypes.FETCH_BUSINESSES_SUCCESS
  constructor(
    public payload: Organization[],
    public filtered: number,
    public total: number,
  ) {}
}

export class FetchBusinessesFailure implements Action {
  readonly type = businessesTypes.FETCH_BUSINESSES_FAILURE
  constructor(public payload: any) {}
}

export class FetchBusinessRequest implements Action {
  readonly type = businessesTypes.FETCH_BUSINESS_DETAILS_REQUEST
  constructor(public id: number) {}
}

export class FetchBusinessSuccess implements Action {
  readonly type = businessesTypes.FETCH_BUSINESS_DETAILS_SUCCESS
  constructor(public payload: any, public building?: any) {}
}

export class FetchBusinessFailure implements Action {
  readonly type = businessesTypes.FETCH_BUSINESS_DETAILS_FAILURE
  constructor(public payload: any) {}
}

export class FetchPropertyBuildingRequest implements Action {
  readonly type = businessesTypes.FETCH_PROPERTY_BUILDING_REQUEST
  constructor(public id: number, public target: string = 'update') {}
}

export class FetchPropertyBuildingSuccess implements Action {
  readonly type = businessesTypes.FETCH_PROPERTY_BUILDING_SUCCESS
  constructor(public payload: any, public target: string = 'update') {}
}

export class FetchPropertyBuildingFailure implements Action {
  readonly type = businessesTypes.FETCH_PROPERTY_BUILDING_FAILURE
  constructor(public payload: any) {}
}

export class UpdateBusinessRequest implements Action {
  readonly type = businessesTypes.UPDATE_BUSINESS_REQUEST
  constructor(public id: number, public payload: any, public options?: { validate?: boolean }) {}
}

export class UpdateBusinessSuccess implements Action {
  readonly type = businessesTypes.UPDATE_BUSINESS_SUCCESS
  constructor(public payload: any) {}
}

export class UpdateBusinessFailure implements Action {
  readonly type = businessesTypes.UPDATE_BUSINESS_FAILURE
  constructor(public payload: any) {}
}

export class CreateBusinessRequest implements Action {
  readonly type = businessesTypes.CREATE_BUSINESS_REQUEST
  constructor(public payload: any) {}
}

export class CreateBusinessSuccess implements Action {
  readonly type = businessesTypes.CREATE_BUSINESS_SUCCESS
  constructor(public payload: any) {}
}

export class CreateBusinessFailure implements Action {
  readonly type = businessesTypes.CREATE_BUSINESS_FAILURE
  constructor(public payload: any) {}
}

export class ArchiveBusinessRequest implements Action {
  readonly type = businessesTypes.ARCHIVE_BUSINESS_REQUEST
  constructor(public id: number) {}
}

export class ArchiveBusinessSuccess implements Action {
  readonly type = businessesTypes.ARCHIVE_BUSINESS_SUCCESS
  constructor(public payload: any) {}
}

export class ArchiveBusinessFailure implements Action {
  readonly type = businessesTypes.ARCHIVE_BUSINESS_FAILURE
  constructor(public payload: any) {}
}

// Common

export class UpdateField implements Action {
  readonly type = businessesTypes.UPDATE_FIELD
  public constructor(
    public field: string,
    public value: any,
    public path: string,
  ) {}
}

export class FetchBusinessDocumentsRequest implements Action {
  readonly type = businessesTypes.FETCH_BUSINESS_DOCUMENTS_REQUEST
  constructor(public id: any) {}
}

export class FetchBusinessDocumentsSuccess implements Action {
  readonly type = businessesTypes.FETCH_BUSINESS_DOCUMENTS_SUCCESS
  constructor(public payload: any) {}
}

export class FetchBusinessDocumentsFailure implements Action {
  readonly type = businessesTypes.FETCH_BUSINESS_DOCUMENTS_FAILURE
  constructor(public payload: any) {}
}

export class FetchBusinessPaymentsRequest implements Action {
  readonly type = businessesTypes.FETCH_BUSINESS_PAYMENTS_REQUEST
  constructor(public id: number) {}
}

export class FetchBusinessPaymentsSuccess implements Action {
  readonly type = businessesTypes.FETCH_BUSINESS_PAYMENTS_SUCCESS
  constructor(public payload: any) {}
}

export class FetchBusinessPaymentsFailure implements Action {
  readonly type = businessesTypes.FETCH_BUSINESS_PAYMENTS_FAILURE
  constructor(public payload: any) {}
}

export class DownloadBusinessDocumentRequest implements Action {
  readonly type = businessesTypes.DOWNLOAD_BUSINESS_DOCUMENT_REQUEST
  constructor(public payload: any) {}
}

export class DownloadBusinessDocumentSuccess implements Action {
  readonly type = businessesTypes.DOWNLOAD_BUSINESS_DOCUMENT_SUCCESS
  constructor(public payload: any, public document: Map<string, any>) {}
}

export class DownloadBusinessDocumentFailure implements Action {
  readonly type = businessesTypes.DOWNLOAD_BUSINESS_DOCUMENT_FAILURE
  constructor(public payload: any) {}
}

export class GenerateBusinessDocumentRequest implements Action {
  readonly type = businessesTypes.GENERATE_BUSINESS_DOCUMENT_REQUEST
  constructor(public payload: any) {}
}

export class GenerateBusinessDocumentSuccess implements Action {
  readonly type = businessesTypes.GENERATE_BUSINESS_DOCUMENT_SUCCESS
  constructor(public payload: any, public document: Map<string, any>) {}
}

export class GenerateBusinessDocumentFailure implements Action {
  readonly type = businessesTypes.GENERATE_BUSINESS_DOCUMENT_FAILURE
  constructor(public payload: any) {}
}

export class DeleteBusinessDocumentRequest implements Action {
  readonly type = businessesTypes.DELETE_BUSINESS_DOCUMENT_REQUEST
  constructor(public businessId: string) {}
}

export class DeleteBusinessDocumentSuccess implements Action {
  readonly type = businessesTypes.DELETE_BUSINESS_DOCUMENT_SUCCESS
  constructor(public payload: any, public document: Map<string, any>) {}
}

export class DeleteBusinessDocumentFailure implements Action {
  readonly type = businessesTypes.DELETE_BUSINESS_DOCUMENT_FAILURE
  constructor(public payload: any) {}
}

export class CreateBusinessPaymentRequest implements Action {
  readonly type = businessesTypes.CREATE_BUSINESS_PAYMENT_REQUEST
  constructor(public payload: any) {}
}

export class CreateBusinessPaymentSuccess implements Action {
  readonly type = businessesTypes.CREATE_BUSINESS_PAYMENT_SUCCESS
  constructor(public payload: any) {}
}

export class CreateBusinessPaymentFailure implements Action {
  readonly type = businessesTypes.CREATE_BUSINESS_PAYMENT_FAILURE
  constructor(public payload: any) {}
}

export class UpdateBusinessPaymentRequest implements Action {
  readonly type = businessesTypes.UPDATE_BUSINESS_PAYMENT_REQUEST
  constructor(public payload: any) {}
}

export class UpdateBusinessPaymentSuccess implements Action {
  readonly type = businessesTypes.UPDATE_BUSINESS_PAYMENT_SUCCESS
  constructor(public payload: any) {}
}

export class UpdateBusinessPaymentFailure implements Action {
  readonly type = businessesTypes.UPDATE_BUSINESS_PAYMENT_FAILURE
  constructor(public payload: any) {}
}

export class DeleteBusinessPaymentRequest implements Action {
  readonly type = businessesTypes.DELETE_BUSINESS_PAYMENT_REQUEST
  constructor(public payload: any) {}
}

export class DeleteBusinessPaymentSuccess implements Action {
  readonly type = businessesTypes.DELETE_BUSINESS_PAYMENT_SUCCESS
  constructor(public payload: any) {}
}

export class DeleteBusinessPaymentFailure implements Action {
  readonly type = businessesTypes.DELETE_BUSINESS_PAYMENT_FAILURE
  constructor(public payload: any) {}
}

export class DownloadBusinessPaymentRequest implements Action {
  readonly type = businessesTypes.DOWNLOAD_BUSINESS_PAYMENT_REQUEST
  constructor(public payload: any) {}
}

export class DownloadBusinessPaymentSuccess implements Action {
  readonly type = businessesTypes.DOWNLOAD_BUSINESS_PAYMENT_SUCCESS
  constructor(public payload: any) {}
}

export class DownloadBusinessPaymentFailure implements Action {
  readonly type = businessesTypes.DOWNLOAD_BUSINESS_PAYMENT_FAILURE
  constructor(public payload: any) {}
}

export class UploadBusinessImageRequest implements Action {
  readonly type = businessesTypes.UPLOAD_BUSINESS_IMAGE_REQUEST
  constructor(public id: number, public payload: any) {}
}

export class UploadBusinessImageSuccess implements Action {
  readonly type = businessesTypes.UPLOAD_BUSINESS_IMAGE_SUCCESS
  constructor(public payload: object) {}
}

export class UploadBusinessImageFailure implements Action {
  readonly type = businessesTypes.UPLOAD_BUSINESS_IMAGE_FAILURE
  constructor(public payload: any) {}
}

export class DeleteBusinessImageRequest implements Action {
  readonly type = businessesTypes.DELETE_BUSINESS_IMAGE_REQUEST
  constructor(public id: number, public imageTypeId: number) {}
}

export class DeleteBusinessImageSuccess implements Action {
  readonly type = businessesTypes.DELETE_BUSINESS_IMAGE_SUCCESS
  constructor(public payload: object) {}
}

export class DeleteBusinessImageFailure implements Action {
  readonly type = businessesTypes.DELETE_BUSINESS_IMAGE_FAILURE
  constructor(public payload: any) {}
}

export class UploadDocumentRequest implements Action {
  readonly type = businessesTypes.UPLOAD_DOCUMENT_REQUEST
  constructor(public id: any, public payload: any) {}
}

export class UploadDocumentSuccess implements Action {
  readonly type = businessesTypes.UPLOAD_DOCUMENT_SUCCESS
  constructor(public payload: any) {}
}

export class UploadDocumentFailure implements Action {
  readonly type = businessesTypes.UPLOAD_DOCUMENT_FAILURE
  constructor(public payload: any) {}
}

export class DeleteDocumentRequest implements Action {
  readonly type = businessesTypes.DELETE_DOCUMENT_REQUEST
  constructor(public id: any) {}
}

export class DeleteDocumentSuccess implements Action {
  readonly type = businessesTypes.DELETE_DOCUMENT_SUCCESS
  constructor(public payload: any) {}
}

export class DeleteDocumentFailure implements Action {
  readonly type = businessesTypes.DELETE_DOCUMENT_FAILURE
  constructor(public payload: any) {}
}

export class SetDefaultData implements Action {
  readonly type = businessesTypes.SET_DEFAULT_DATA
  public constructor(public path: string) {}
}

export type Actions =
  | SetDefaultData
  | UpdateField
  | FetchBusinessesRequest
  | FetchBusinessesSuccess
  | FetchBusinessesFailure
  | FetchBusinessRequest
  | FetchBusinessSuccess
  | FetchBusinessFailure
  | UpdateBusinessRequest
  | UpdateBusinessSuccess
  | UpdateBusinessFailure
  | CreateBusinessRequest
  | CreateBusinessSuccess
  | CreateBusinessFailure
  | ArchiveBusinessRequest
  | ArchiveBusinessSuccess
  | ArchiveBusinessFailure
  | FetchPropertyBuildingRequest
  | FetchPropertyBuildingSuccess
  | FetchPropertyBuildingFailure
  | FetchBusinessDocumentsRequest
  | FetchBusinessDocumentsSuccess
  | FetchBusinessDocumentsFailure
  | FetchBusinessPaymentsRequest
  | FetchBusinessPaymentsSuccess
  | FetchBusinessPaymentsFailure
  | DownloadBusinessDocumentRequest
  | DownloadBusinessDocumentSuccess
  | DownloadBusinessDocumentFailure
  | CreateBusinessPaymentRequest
  | CreateBusinessPaymentSuccess
  | CreateBusinessPaymentFailure
  | UpdateBusinessPaymentRequest
  | UpdateBusinessPaymentSuccess
  | UpdateBusinessPaymentFailure
  | DeleteBusinessPaymentRequest
  | DeleteBusinessPaymentSuccess
  | DeleteBusinessPaymentFailure
  | DownloadBusinessPaymentRequest
  | DownloadBusinessPaymentSuccess
  | DownloadBusinessPaymentFailure
  | UploadBusinessImageRequest
  | UploadBusinessImageSuccess
  | UploadBusinessImageFailure
  | DeleteBusinessImageRequest
  | DeleteBusinessImageSuccess
  | DeleteBusinessImageFailure
  | GenerateBusinessDocumentRequest
  | GenerateBusinessDocumentSuccess
  | GenerateBusinessDocumentFailure
  | DeleteBusinessDocumentRequest
  | DeleteBusinessDocumentSuccess
  | DeleteBusinessDocumentFailure
  | UploadDocumentRequest
  | UploadDocumentSuccess
  | UploadDocumentFailure
  | DeleteDocumentRequest
  | DeleteDocumentSuccess
  | DeleteDocumentFailure
